import { useEffect } from 'react';

const IOSDetector = () => {
  useEffect(() => {
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (isIOS) {
      document.body.classList.add('ios');
    }
  }, []);

  return null;
};

export default IOSDetector;
